import { MessageContentProps } from './Types'
import { TextMessageRenderer } from './TextMessageRenderer'
import { ProcessingContent } from './ProcessingContent'
import { ProcessingSteps } from './ProcessingSteps/ProcessingSteps'
import { DesignContent } from './DesignPreview/DesignContent'
import { CaptionsContent } from './CaptionsContent/CaptionsContent'
import { UnsupportedRequestContent } from './UnsupportedRequestContent/UnsupportedRequestContent'
import { GeneratedMediaContent } from './GeneratedMediaContent/GeneratedMediaContent'
import { ImageContent } from './ImageContent/ImageContent'
import { InsufficientCreditsContent } from './InsufficientCreditsContent/InsufficientCreditsContent'
import { CreditUsageContent } from './CreditUsageContent/CreditUsageContent'
import { ComparisonResolvedContent } from './ComparisonResolvedContent/ComparisonResolvedContent'
import { SuggestedFollowupsContent } from './SuggestedFollowupsContent/SuggestedFollowupsContent'

export const MessageContent = ({ content, message, isNextGen, context, isDisabled }: MessageContentProps) => {
  if (content.type === 'text') {
    return <TextMessageRenderer isNextGen={isNextGen}>{content.text + ''}</TextMessageRenderer>
  } else if (content.type === 'image') {
    return <ImageContent content={content} />
  } else if (content.type === 'processing') {
    return <ProcessingContent content={content} message={message} isNextGen={isNextGen} />
  } else if (content.type === 'design_content') {
    return (
      <DesignContent
        content={content.content}
        width={content.width}
        height={content.height}
        design_id={content.design_id}
      />
    )
  } else if (content.type === 'captions') {
    return <CaptionsContent content={content} />
  } else if (content.type === 'unsupported_request') {
    return <UnsupportedRequestContent content={content} isNextGen={isNextGen} />
  } else if (content.type === 'generation_steps') {
    return <ProcessingSteps steps={content.steps} isNextGen={isNextGen} isCompleted />
  } else if (content.type === 'generated_image' || content.type === 'generated_video') {
    if (isNextGen) return null
    if (content.type === 'generated_image' && content.action) return null
    return <GeneratedMediaContent content={content} />
  } else if (content.type === 'insufficient_credits') {
    return <InsufficientCreditsContent content={content} message={message} />
  } else if (content.type === 'credit_usage') {
    if (isNextGen) return null
    return <CreditUsageContent content={content} />
  } else if (content.type === 'comparison_resolved') {
    return <ComparisonResolvedContent content={content} message={message} />
  } else if (content.type === 'suggested_followups') {
    return (
      <SuggestedFollowupsContent
        content={content}
        threadId={message.thread_id}
        context={context}
        isDisabled={isDisabled ?? false}
      />
    )
  }

  return null
}
